module.exports = __webpack_public_path__ + "edd6f558a0683a36b30bab59355fb137.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/fire-hair.png
// module id = 2805
// module chunks = 0